var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrokenImageIcon = function SvgBrokenImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3D5",
    d: "M24 2v20c0 1-1 2-2 2h-7.5L13 22.182h9.122V17.6L18.297 12a.758.758 0 0 0-1.165 0l-2.892 3.382L11.497 12l2.968-3.636a.904.904 0 0 0 0-1.128L11.497 3.6 14.5 0H22c1 0 2 1 2 2M1.878 21.346v.836H10.5L12 24H2c-1 0-2-1-2-2V2c0-1 1-2 2-2h10L9.544 3.055c-.263.327-.263.8 0 1.09l2.968 3.637-2.968 3.636a.904.904 0 0 0 0 1.128l2.968 3.636-2.668 3.273s-.112-.073-.15-.146l-2.968-3.455a.758.758 0 0 0-1.164 0zM3.834 7.455c0 1.527 1.277 2.763 2.855 2.763s2.855-1.236 2.855-2.763c0-1.528-1.277-2.764-2.855-2.764S3.834 5.927 3.834 7.455"
  })));
};
export default SvgBrokenImageIcon;